// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce752463","732":"d94322d0","977":"1f0019be"}[chunkId] + ".chunk.js";
};